import { useEffect, useState } from "react";
import { Disclosure, Transition } from "@headlessui/react";
import styles from "./index.module.css";
import {  NavLink, useLocation } from "react-router-dom";
import { TiArrowSortedDown } from "react-icons/ti";
import ApiClient from "../../../methods/api/apiClient";
import { FiUsers } from "react-icons/fi";
import { MdSpaceDashboard, MdStore } from "react-icons/md";
import { FaUser } from "react-icons/fa";
import { MdCategory } from "react-icons/md";
import { MdListAlt } from "react-icons/md";
import { FaUsers } from "react-icons/fa";
import { FaCar } from "react-icons/fa";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { MdPayments } from "react-icons/md";
import { MdSettings } from "react-icons/md";
import { FaMapLocationDot } from "react-icons/fa6";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
import { IoCodeSharp } from "react-icons/io5";
import { RiCalendar2Line } from "react-icons/ri";
import { SiSitepoint } from "react-icons/si";
import { MdAdminPanelSettings } from "react-icons/md";
import { FaClipboardUser } from "react-icons/fa6";
import { MdOutlineManageHistory } from "react-icons/md";
import { BsFillFileEarmarkBarGraphFill, BsFillPersonVcardFill } from "react-icons/bs";

import environment from "../../../environment";
import { GrDocumentPerformance } from "react-icons/gr";

const Html = ({ ListItemLink, tabclass, isAllow, route, isOpen, user }) => {
  const [activeplan, setActiveplan] = useState();
  const role = user?.customerRole?.name === "Group Leader";
  const getactivePlan = () => {
    let filter = {};
    if (user?.subRole?.id == environment.SubRolePartner) {
      filter = { id: user.id || user?._id };
    } else {
      filter = {};
    }
    ApiClient.get("api/getMyPlan", filter).then((res) => {
      if (res.success) {
        setActiveplan(res?.data);
      }
    });
  };

  const location = useLocation();
  useEffect(() => {
    if (user?.customerRole?.name === "Group Leader") {
      getactivePlan();
    }
  }, []);

  const activecls = (tab) => {
    let url = window.location.href;
    let value = false;
    tab?.map((itm) => {
      if (url.includes(itm)) value = true;
    });
    return value;
  };

  const menus = [
    {
      name: "Dashboard",
      icon: (
        <MdSpaceDashboard className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
      ),
      activeIcon: (
        <MdSpaceDashboard className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
      ),
      url: "/dashboard",
      key: "readDashboard",
    },
    {
      name: "Sub Admin",
      icon: (
        <MdAdminPanelSettings className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
      ),
      activeIcon: (
        <MdAdminPanelSettings className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
      ),
      url: "/subadmin",
      key: "readsubadmin",
    },
    {
      name: "Location",
      icon: <FaMapLocationDot className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
      activeIcon: <FaMapLocationDot className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
      url: "/location",
      key: "readLocation",
    },
    
    
    
    {
      name: "Store Management",
      icon: (
        <MdStore className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
      ),
      activeIcon: (
        <MdStore className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
      ),
      url: "/store",
      key: "readstore",
    },
    {
      name: "Manager Management",
      icon: (
        <FaClipboardUser className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
      ),
      activeIcon: (
        <FaClipboardUser className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
      ),
      url: "/manager",
      key: "readManager",
    },
    {
      name: "Staff Management",
      icon: (
        <FaUsers className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
      ),
      activeIcon: (
        <FaUsers className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
      ),
      url: "/staff",
      key: "readStaff",
    },
    {
      name: "Store Performance",
      icon: (
        <BsFillFileEarmarkBarGraphFill className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
      ),
      activeIcon: (
        <BsFillFileEarmarkBarGraphFill className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
      ),
      url: "/performance",
      key: "readperformance",
    },
    {
      name: "Supplier Management",
      icon: (
        <BsFillPersonVcardFill className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
      ),
      activeIcon: (
        <BsFillPersonVcardFill className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
      ),
      url: "/supplier",
      key: "readsupplier",
    },
     // {
    //   name: "Bookings Calendar",
    //   icon: <RiCalendar2Line className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
    //   activeIcon: <RiCalendar2Line className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
    //   url: "/calendar",
    //   key: "readBookings",
    // },
    // {
    //   name: "Bookings",
    //   icon: <MdOutlineCalendarMonth className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
    //   activeIcon: <MdOutlineCalendarMonth className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
    //   url: "/booking",
    //   key: "readBookings",
    // },
    // {
    //   name: "Payments",
    //   icon: <MdPayments className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
    //   activeIcon: <MdPayments className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
    //   url: "/payment",
    //    key: "readPayment",
    // },
    // {
    //   name: "Roles and Permissions",
    //   icon: <img src="/assets/img/role.svg" alt=""/>,
    //   activeIcon: <img src="/assets/img/role-blue.svg" alt=""/>,
    //   url: "/role",
    //   key: "readRoles",
    // },
    


    // {
    //   name: "Customer",
    //   icon: <FaUsers className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
    //   activeIcon: <FaUsers className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
    //   url: "/customer",
    //   key: "readcustomer",
    // },
   
    // {
    //   name: "Vehicle Type",
    //   icon: <FaCar className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
    //   activeIcon: <FaCar className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
    //   url: "/vehicle",
    //   key: "readVehicle",
    // },
   
    // {
    //   name: "Rates",
    //   icon: <RiMoneyDollarCircleFill className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
    //   activeIcon: <RiMoneyDollarCircleFill className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
    //   url: "/rate",
    //   key: "readrates",
    // },
    // {
    //   name: "Products Store",
    //   icon: <MdListAlt className="text-[20px]" />,
    //   activeIcon: <MdListAlt className="text-[20px]" />,
    //   menu: [
    //     {
    //       name: "Products",
    //       icon: <FiUsers className="text-[20px]" />,
    //       url: "/product",
    //       key: "readProduct",
    //     },
    //     {
    //       name: "Product Category",
    //       icon: <FiUsers className="text-[20px]" />,
    //       url: "/ProductCategory",
    //       key: "readProductCategory",
    //     },
    //     {
    //       name: "Orders",
    //       icon: <FiUsers className="text-[20px]" />,
    //       url: "/order",
    //       key: "readOders",
    //     },
    //   ],
    // },
    
    // {
    //   name: "Categories",
    //   icon: (
    //     <MdCategory className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
    //   ),
    //   activeIcon: (
    //     <MdCategory className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />
    //   ),
    //   url: "/category",
    //   key: "readCategory",
    // },
    
    // {
    //   name: "Script Detail",
    //   icon: <SiSitepoint  className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
    //   activeIcon: <SiSitepoint className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
    //   url: "/sitedetails",
    //   key: "readSite",
    // },
    // {
    //   name: "Shift Managemant",
    //   icon: <MdOutlineManageHistory className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
    //   activeIcon: <MdOutlineManageHistory className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
    //   url: "/Shift",
    //   key: "readShift",
    // },
    // {
    //   name: "Settings",
    //   icon: <MdSettings className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
    //   activeIcon: <MdSettings className="w-[30px] h-[30px] p-[5px] bg-[#fff] rounded-full" />,
    //   url: "/setting",
    //   key: "readrates",
    // },
   
    
    // {
    //   name: "Geo",
    //   icon: <IoGitMergeOutline className="text-[20px]" />,
    //   activeIcon: <IoGitMergeOutline className="text-[20px]" />,
    //   key:"readGeo",
    //   menu: [
    //     {
    //       name: "Continent",
    //       icon: <FiUsers className="text-[20px]" />,
    //       url: "/continent",
    //       key: "readGeo",
    //     },
    //     {
    //       name: "Country",
    //       icon: <FiUsers className="text-[20px]" />,
    //       url: "/country",
    //       key: "readGeo",
    //     },
    //     {
    //       name: "State",
    //       icon: <FiUsers className="text-[20px]" />,
    //       url: "/state",
    //       key: "readGeo",
    //     },
    //     {
    //       name: "City",
    //       icon: <FiUsers className="text-[20px]" />,
    //       url: "/city",
    //       key: "readGeo",
    //     },
    //   ],
    // },
    // {
    //   name: "FAQ",
    //   icon: <FaQuestion className="text-[20px]" />,
    //   activeIcon: <FaQuestion className="text-[20px]" />,
    //   url: "/faqs",
    //   key: "readFaq",
    // },
    // {
    //   name: "Blogs",
    //   icon:<FaBloggerB className="text-[20px]" />,
    //   activeIcon: <FaBloggerB className="text-[20px]" />,
    //   url: "/blogs",
    //   key: "readBlogs",
    // },
    // {
    //   name: "Site Details",
    //   icon: <TbListDetails className="text-[20px]" />,
    //   activeIcon: <TbListDetails className="text-[20px]" />,
    //   url: "/sitedetails",
    //   key: "readSite",
    // },
    // {
    //   name: "Content Management",
    //   icon: <MdOutlineManageAccounts className="text-[20px]" />,
    //   activeIcon: <MdOutlineManageAccounts className="text-[20px]" />,
    //   url: "/content",
    //   key:'readContent'
    // },
  ];

  return (
    <>
      <div
        className={`px-[12px] sidebar-padding ${isOpen && styles.sm_sidebar}`}
        component="siderbar"
      >
        <ul className="space-y-2 ">
          {menus.map((itm) => {
            return (
              <>
                {itm.icon ? (
                  <>
                    <li>
                      {itm.menu ? (
                        <>
                          {isAllow(
                            itm.menu.map((itm) => itm.key).toString()
                          ) ? (
                            <>
                              <Disclosure
                                as="div"
                                defaultOpen={activecls(
                                  itm.menu.map((itm) => itm.url)
                                )}
                              >
                                {({ open }) => (
                                  <>
                                    <tooltip placement="right" title={itm.name}>
                                      <Disclosure.Button className="w-full p-4 rounded-md flex items-center justify-between gap-[12px] transition-all duration-300 sidebar-drop">
                                        <span className="text-sm fow-full  rounded-md flex items-center justify-between gap-[12px] transition-all duration-300nt-normal text-inherit flex items-center gap-[12px] crm ">
                                          {!open ? (
                                            <>{itm?.icon}</>
                                          ) : (
                                            <>{itm?.activeIcon}</>
                                          )}
                                          <span className="text-inherit leading-none sidebar_text">
                                            {itm.name}
                                          </span>
                                        </span>
                                        <TiArrowSortedDown
                                          className={`${
                                            open ? "" : "-rotate-90 transform"
                                          } h-3 w-3 transition-all duration-500`}
                                        />
                                      </Disclosure.Button>
                                    </tooltip>
                                    <Transition
                                      enter="transition duration-300 ease-in-out"
                                      enterFrom="transform scale-95 opacity-0"
                                      enterTo="transform scale-300 opacity-300"
                                      leave="transition duration-300 ease-in-out"
                                      leaveFrom="transform scale-300 opacity-300"
                                      leaveTo="transform scale-95 opacity-0"
                                    >
                                      <Disclosure.Panel className=" mt-[4px] ">
                                        <ul className="space-y-2">
                                          {itm.menu?.map((sitm) => {
                                            return (
                                              <>
                                                {isAllow(sitm.key) ? (
                                                  <li className="px-4">
                                                    {" "}
                                                    <NavLink
                                                      className={(isActive) =>
                                                        "p-4 rounded-md block text-sm font-normal text-[#333] cursor-pointer !no-underline transition-all " +
                                                        (location?.pathname.includes(
                                                          sitm.url
                                                        ) &&
                                                          " !text-[#3C73AA] !bg-[#4d899247]  !font-medium")
                                                      }
                                                      to={sitm.url}
                                                    >
                                                      <div className="flex items-center relative ">
                                                        <span className="w-[7px] h-[7px] bg-[#596b77] rounded-full block absolute -left-[4px]"></span>
                                                        <span
                                                          className="text-inherit leading-none sidebar_text ps-5"
                                                          title={sitm.name}
                                                        >
                                                          {sitm.name}
                                                        </span>
                                                      </div>
                                                    </NavLink>
                                                  </li>
                                                ) : null}
                                              </>
                                            );
                                          })}
                                        </ul>
                                      </Disclosure.Panel>
                                    </Transition>
                                  </>
                                )}
                              </Disclosure>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <>
                          {isAllow(itm.key) ? (
                            <>
                              <tooltip
                                placement="top"
                                color="#3730ff"
                                title={itm.name}
                              >
                                <NavLink
                                  to={itm.url}
                                  className={(isActive) =>
                                    "px-2 py-3 rounded-md flex items-center gap-[12px] text-sm font-normal text-[#5B6670] hover:!text-[#3C73AA] hover:bg-[#3C73AA]/20 !no-underline transition-all " +
                                    (location?.pathname.includes(itm.url) &&
                                      " !text-[#3C73AA] !bg-[#3C73AA]/20 !font-medium")
                                  }
                                >
                                  {!location?.pathname.includes(itm.url) ? (
                                    <>{itm.icon}</>
                                  ) : (
                                    <>{itm?.activeIcon}</>
                                  )}

                                  <span className="text-inherit leading-none sidebar_text">
                                    {itm.name}
                                  </span>
                                </NavLink>
                              </tooltip>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </li>
                  </>
                ) : (
                  <>
                    <li>
                      <h6
                        className={`${
                          isOpen ? "py-[12px] " : "p-[12px]  text-md"
                        } text-xs font-medium text-[#7E8B99] mt-[12px]`}
                      >
                        <span className=" sidebar_text text-center">
                          {" "}
                          {itm.name}{" "}
                        </span>
                      </h6>
                    </li>
                  </>
                )}
              </>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default Html;
